// Milestone map for the claim-intake wizard. Only the happy-path routes are
// represented here — legacy/experimental routes intentionally opt out of the
// step indicator (see docs/ROUTE-MATRIX.md) rather than show a misleading step.
export interface Milestone {
  key: string;
  label: string;
  matches: (pathname: string) => boolean;
}

export const MILESTONES: Milestone[] = [
  {
    key: "victim",
    label: "Мэдээлэл",
    matches: (p) => p === "/victim",
  },
  {
    key: "vehicle",
    label: "Тээврийн хэрэгсэл",
    matches: (p) => p === "/xyp-vehicle-info",
  },
  {
    key: "photos",
    label: "Зураг авах",
    matches: (p) =>
      p === "/damages" ||
      p === "/take-photos-instructions" ||
      p.startsWith("/camera-mask") ||
      p === "/progress",
  },
  {
    key: "result",
    label: "Үнэлгээ",
    matches: (p) => p === "/result",
  },
  {
    key: "invoice",
    label: "Нэхэмжлэх",
    matches: (p) => p === "/calculations" || p === "/invoice",
  },
];

export const getActiveMilestoneIndex = (pathname: string): number =>
  MILESTONES.findIndex((m) => m.matches(pathname));
